import React, { Component } from 'react';


class SignedIn extends Component {

  render() {
    return(
      <div className={this.props.signedInPopup ? "SignedIn" : "SignedIn hidden"}>
        <p>Välkommen!</p>
      </div>
    )
  }
}

export default SignedIn;



// WEBPACK FOOTER //
// ./src/components/SignedIn.jsx